import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const CREATE_DISCOUNT = SERVER_URI + '/discount-reasons';
const GET_DISCOUNT_REASON = SERVER_URI + '/get-discount-reasons';
const CHANGE_DISCOUNT_STATUS = SERVER_URI + '/discount-reason-status/';
const UPDATE_DISCOUNT_STATUS = SERVER_URI + '/discount-reasons/';

export default {

    createDiscount:async function(paylaod){
      console.log("discount payload", paylaod)
      return apiPost(CREATE_DISCOUNT,paylaod)
    },
    getDiscountReason: async function (payload) {
        return apiPost(GET_DISCOUNT_REASON,payload);
      },
      changeDiscountStatus: async function (id) {
        return apiGet(CHANGE_DISCOUNT_STATUS + id);
      },
      updateDiscountStatus: async function (id,payload) {
        console.log("immd.....", id,payload)
        return apiPut(UPDATE_DISCOUNT_STATUS +id,payload)
      }
    
}